import React, { FC } from 'react';
import Barcode from 'react-barcode';
import { Typography } from '@one-thd/sui-atomic-components';
import { defaultImage, DEFAULT_GIFT_CARD_NAME } from '../../utils/consts';
import { formatGiftCardNumber } from '../../utils/utils';
import { formatDollar } from '../../utils/general';
import { IGiftCardCommonData } from '../../models/common-models';
import { BarcodeTimerContainer } from './barcode-timer-container';

interface GiftCardBarcodeProps {
  giftCard: IGiftCardCommonData;
  onClose: () => void;
}

export const GiftCardBarcode: FC<GiftCardBarcodeProps> = ({
  giftCard,
  onClose,
}) => {
  const giftCardNumber = giftCard.barcode || '';
  const giftCardPinNumber = giftCard.pin;

  return (
    <div className="sui-text-center">
      <div className="sui-flex sui-items-center sui-justify-start sui-gap-x-2 sui-w-full sui-px-4 sui-py-2">
        <img
          src={giftCard?.imagePath || defaultImage}
          width="54"
          height="30"
          alt="Gift Card"
          data-testid="scan-to-pay-gift-card-image"
          className="sui-rounded-md"
        />
        <Typography variant="h3">{giftCard?.nickName || DEFAULT_GIFT_CARD_NAME}</Typography>
      </div>
      <div className="sui-text-center sui-pt-2 sui-pb-4">
        <div className="sui-flex sui-justify-center sui-w-full">
          <Barcode value={giftCardNumber} displayValue={false} />
        </div>
        <div className="sui-text-center sui-pt-2">
          <div className="sui-pb-2">
            <Typography variant="body-lg">
              {formatGiftCardNumber(giftCardNumber?.slice(4, 16))}
            </Typography>
          </div>
          <Typography variant="body-lg">PIN: {giftCardPinNumber}</Typography>
        </div>
      </div>
      <div className="sui-pb-4">
        <Typography variant="h2">
          Current Balance:{' '}
          {giftCard?.availableBalance ? formatDollar(giftCard.availableBalance) : '$0.00'}
        </Typography>
      </div>
      <BarcodeTimerContainer onClose={onClose} />
    </div>
  );
};
